import { InfoWindow } from '@react-google-maps/api';
import { useClickOutside } from '../../../Hooks/useClickOutside';
import React, { useEffect, useRef } from 'react';
import { PopupWindowContainer } from '../../../SharedComponets/PopupWindow';

interface RestFacilitiesPopUpWindowProps {
  restRoom: any;
  setSelectedRestRoom: (restRoom: any) => void;
  setMapCenter: (center: { lat: number; lng: number }) => void;
  setZoomLevel: (zoom: number) => void;
  markerOpenRef: React.RefObject<any>;
}

const RestFacilitiesPopUpWindow: React.FC<RestFacilitiesPopUpWindowProps> = (
  props
) => {
  const {
    restRoom,
    setSelectedRestRoom,
    markerOpenRef,
    setMapCenter,
    setZoomLevel
  } = props;

  const MarkerExcludedRef = useRef(null);

  useClickOutside(
    markerOpenRef,
    () => {
      setSelectedRestRoom(null);
    },
    [MarkerExcludedRef]
  );

  useEffect(() => {
    setZoomLevel(16);
    setMapCenter({
      lat: restRoom.Latitude,
      lng: restRoom.Longitude
    });
  }, [restRoom, setSelectedRestRoom]);

  return (
    <InfoWindow
      onCloseClick={() => setSelectedRestRoom(null)}
      position={{
        lat: restRoom.Latitude,
        lng: restRoom.Longitude
      }}
    >
      <PopupWindowContainer
        ref={markerOpenRef}
        title="Rest Room"
        onClose={() => {
          if (restRoom) setSelectedRestRoom(null);
        }}
      >
        <h6>{restRoom.Name}</h6>
        <div className="row latitude-longitude-section mx-0">
          <div className="col-sm-6 pe-1 ps-0">
            <label>Latitude</label>
            <p>{restRoom.Latitude}</p>
          </div>
          <div className="col-sm-6 pe-1 ps-0">
            <label>Longitude</label>
            <p>{restRoom.Longitude}</p>
          </div>
        </div>

        <div className="group mt-3">
          <label>Location</label>
          <p>{restRoom.Location}</p>
        </div>

        <div className="group mt-3">
          <label>Status</label>
          <p>{restRoom.Status}</p>
        </div>
      </PopupWindowContainer>
    </InfoWindow>
  );
};

export default RestFacilitiesPopUpWindow;
